import { render, staticRenderFns } from "./reset-pass.vue?vue&type=template&id=8311c45a"
import script from "./reset-pass.vue?vue&type=script&lang=js"
export * from "./reset-pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports